import { n as getProjectMeta, r as deleteMeta, t as setMeta } from "./setMeta2.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/project-gge/projectMetaController/hooks/useDeleteMeta.ts
const deleteMetaMutationKey = () => [{ url: "/meta/:projectId/:metaKey" }];
function deleteMetaMutationOptions(config = {}) {
	const mutationKey = deleteMetaMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteMeta({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить мета объект из проекта по id проекта и key меты.
* {@link /meta/:projectId/:metaKey}
*/
function useDeleteMeta(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteMetaMutationKey();
	const baseOptions = deleteMetaMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/project-gge/projectMetaController/hooks/useGetProjectMeta.ts
const getProjectMetaQueryKey = ({ path }) => [{
	url: "/meta/:projectId",
	params: path
}];
function getProjectMetaQueryOptions({ path }, config = {}) {
	const queryKey = getProjectMetaQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getProjectMeta({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список меты проекта по id проекта.
* {@link /meta/:projectId}
*/
function useGetProjectMeta({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getProjectMetaQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getProjectMetaQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectMetaController/hooks/useSetMeta.ts
const setMetaMutationKey = () => [{ url: "/meta/:projectId/key/:key" }];
function setMetaMutationOptions(config = {}) {
	const mutationKey = setMetaMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await setMeta({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Обновить мета объект или вставить новый. Сравнивает мета объекты по полю 'key'.
* {@link /meta/:projectId/key/:key}
*/
function useSetMeta(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? setMetaMutationKey();
	const baseOptions = setMetaMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { getProjectMetaQueryOptions as a, deleteMetaMutationOptions as c, getProjectMetaQueryKey as i, useDeleteMeta as l, setMetaMutationOptions as n, useGetProjectMeta as o, useSetMeta as r, deleteMetaMutationKey as s, setMetaMutationKey as t };

//# sourceMappingURL=useSetMeta2.js.map